import axios from 'axios'
import CS from '../../../commons/services/Common'
import { ROUTES } from '../../../commons/constants/routes/routes';

class Authentication {

    // send username, password to the SERVER
    executeJwtAuthenticationService(username, password) {
        return axios.post('/api/jwt/authenticate', {
            username,
            password
        })
    }

    onJwtLoginSuccess(token, userInfo) {
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('id', userInfo.id);
        sessionStorage.setItem('userId', userInfo.userId);
        sessionStorage.setItem('userName', userInfo.userName);
        // sessionStorage.setItem('plantIds', userInfo.plantIds);
        sessionStorage.setItem('tempYn', userInfo.tempYn);

        if(userInfo.tempYn) {
            CS.notification('warning', '임시로 발급된 비밀번호 입니다. 변경 후 다시 이용 바랍니다.');
            setTimeout(function() {
                window.location.href = ROUTES.MYPAGE;
            }, 2000);
        }

        setTimeout(function() {
            executeJwtTokenRefresh(token, userInfo.userId);
        }, 10 * (1*60*1000) );

        const executeJwtTokenRefresh = (token, username) => {
            this.executeJwtTokenRefresh(token, userInfo.userId);
        }
    }


    executeJwtTokenRefresh(token, username) {
        return axios.post('/api/jwt/authenticate/refresh', {
            token,
            username
        }).then((res) => {
            this.onJwtLoginSuccess(res.data.jwtToken, res.data.userInfo);
        }).catch(() => {
            this.logout();
        });
    }

    
    isUserLoggedIn() {
        const token = sessionStorage.getItem('token');
        if (token) {
            return true;
        }
        return false;
    }

    getLoggedInUserName() {
        let user = sessionStorage.getItem('userId');
        if(user===null) return '';
        return user;
    }

    getLoggedInUserId() {
        let userId = sessionStorage.getItem('userId');
        if(userId===null) return '';
        return userId;
    }

    getLoggedInId() {
        let id = sessionStorage.getItem('id');
        if(id===null) return '';
        return id;
    }

    getLoggedInPlantInfos() {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        if(userInfo === null) return '';
        // console.log("getLoggedInPlantInfos called")
        return userInfo.plantInfos;
    }

    isAuthPlant(plantId) {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        plantId = Number(plantId);
        const plantIds = userInfo.plantInfos.map(plant => plant.id);
        // return userInfo.plantIds.indexOf(plantId) > -1;
        return plantIds.indexOf(plantId) > -1;
    }


    logout() {
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("userName");
        sessionStorage.removeItem("token");
        window.location.href = "/";
    }

}

export default new Authentication()
